<template>
  <div :class="video_popup_class" @click="click_close_popup">
    <div
      class="popup_content_container w-full max-w-4xl mx-auto text-left bg-white shadow-md rounded px-10 pt-16 pb-8 mb-4 relative"
      @click="prevent_close($event)"
    >
      <div class="option-bar">
        <span class="close-link" @click="close_popup">X</span>
      </div>
      <h1 class="text-red-500 uppercase font-bold mb-8 text-center">
        {{ getCurrentSectionContent().title }}
      </h1>

      <ul :class="pdf_list_class" v-if="!show_slideshow">
        <li
          class="border-red-100 border-b-2 my-1"
          v-for="(item, index) in getCurrentSectionContent().list"
          :key="'pdf_list_item_' + index"
        >
          <a
            class="block px-4 py-2 bg-gray-100 rounded hover:bg-gray-200 shadow-md"
            target="_blank"
            href="#"
            @click="on_request_slideshow($event, index)"
            ><img
              :src="
                'static/content/' + current_section + '/thumb/' + item.thumb
              "
            /><span>{{ item.title }}</span></a
          >
        </li>
      </ul>
      <div v-else>
        <div class="back-bar">
          <a href="#" class="back-link" @click="back_to_list($event)">Back</a>
        </div>
        <vueper-slides
          :slide-ratio="slide_ratio"
          :fixed-height="false"
          arrows-outside
          bullets-outside
          fade
          @before-slide="on_before_slide($event)"
        >
          <vueper-slide
            v-for="i in slide_count"
            :key="i"
            :content="slide_src(i)"
          />
        </vueper-slides>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { VueperSlides, VueperSlide } from "vueperslides";
export default {
  name: "LinksPopup",
  components: {
    VueperSlides,
    VueperSlide
  },
  data() {
    return {
      loading: "",
      show_slideshow: false,
      slide_count: 0,
      slide_prefix: "",
      slide_ratio: ""
    };
  },
  computed: {
    ...mapState(["current_section"]),
    ...mapGetters(["sectionContent", "eventTag"]),

    page_url() {
      var str = "/" + this.eventTag + "/popups/links-slideshow/";

      return str;
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    },
    show_instructions() {
      return this.$store.state.app_state != 2;
    },
    video_popup_class() {
      return "popup link-slideshow-popup " + this.loading;
    },
    pdf_list_class() {
      let str = "pdf-list";
      if (this.getCurrentSectionContent().list.length >= 6) {
        str += " md:grid md:gap-3 md:grid-cols-2";
      }
      return str;
    }
  },
  methods: {
    getCurrentSectionContent() {
      return this.sectionContent(this.current_section);
    },
    click_close_popup(e) {
      e.preventDefault();
      this.close_popup(e);
    },
    close_popup(e) {
      console.log("close popup");
      //if(e)
      //e.preventDefault();

      //there's a difference between the number of the transition
      //and what unity's animator is expecting for its param.
      //so unity is always one number ahead
      //quick fix is to send transition number minus one, but let's do better next time\
      if (this.$store.state.app_state == 0) {
        this.$bus.$emit(
          "send_unity_msg",
          "JsRequestTransition",
          parseInt(this.$store.state.popup_video_src, 10)
        );
      }
      this.$store.dispatch("set_popup_state", "");

      this.loading = "loading";
      //this.$bus.$emit('send_unity_msg', 'OnVideoPopupClose', null)
    },
    prevent_close(e) {
      e.stopPropagation();
    },
    video_started() {
      this.loading = "";
      //setTimeout((()=>{this.loading=''}).bind(this), 2000)
    },
    on_request_slideshow(e, index) {
      e.preventDefault();
      this.show_slideshow = true;
      let content = this.getCurrentSectionContent().list[index];
      this.slide_count = content.count;
      this.slide_prefix = content.filename_prefix;
      if ("undefined" != typeof content.slide_ratio) {
        this.slide_ratio = content.slide_ratio;
      } else {
        this.slide_ratio = 1080 / 1920;
      }
    },
    slide_src(idx) {
      let src =
        "static/content/" +
        this.current_section +
        "/" +
        this.slide_prefix +
        idx +
        ".png";
      return '<img src="' + src + '">';
    },
    on_before_slide(e) {},
    back_to_list(e) {
      e.preventDefault();
      this.show_slideshow = false;
      return "";
    }
  },
  mounted() {
    console.log("creating links popup");
    this.$bus.$on("on-request-video-close", this.close_popup);
    this.$ga.page(this.page_url);
  },
  beforeDestroy() {
    console.log("destroying video popup");
    this.$bus.$off("on-request-video-close", this.close_popup);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  xjustify-content: center;
}
.popup_content_container {
  margin-top: auto;
  margin-bottom: auto;
  max-height: calc(var(--vh, 1vh) * 100);
  overflow: auto;
}

.option-bar {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
}
.close-link {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 40px;
  height: 40px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
}
.popup_video_container {
  align-self: center;
  margin: auto 0;
}

.app-popup-instructions {
  background: rgba(20, 20, 20, 0.8);
  text-transform: uppercase;
}

.pdf-list img {
  max-width: 80px;
  height: autopx;
  margin-right: 20px;
  display: inline-block;
}
.pdf-list li a {
  display: flex;
  align-content: center;
  align-items: center;
}
.back-bar {
  position: absolute;
  top: 20px;
  left: 30px;
  background: url("../../assets/icon-back.png") 0 0 no-repeat;
  background-size: contain;
  height: 30px;
  padding-left: 40px;
  line-height: 30px;
  color: #03344a;
}
</style>
<style>
.popup_video_container {
  margin: 0 auto;
}

.link-slideshow-popup .vueperslides__arrow--prev {
  left: -30px !important;
}
.link-slideshow-popup .vueperslides__arrow--next {
  right: -30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/LinksSlideshowPopup.vue